<script>
import Modal from "@/components/_Shared/Modal/Index";
import Title from "@/components/_Shared/Title";
import Tip from "@/components/_base/Tip";

import support from "@/utils/support";

export default {
  components: {
    Modal,
    Title,
    Tip
  },

  methods: {
    openChat() {
      support.openChat();

      this.$emit("close");
    }
  }
};
</script>


<template>
  <Modal>
    <template slot="header">
      <Title title="Abrir ticket de suporte" />
    </template>

    <template slot="body">
      <iframe
        class="support"
        title="Contact Form"
        src="https://plugins.crisp.chat/urn:crisp.im:contact-form:0/contact/187a1456-9194-49dc-8b77-5b5e6ddb4139"
        referrerpolicy="origin"
        sandbox="allow-forms allow-popups allow-scripts allow-same-origin"
        width="100%"
        height="600px"
        frameborder="0"
      ></iframe>
    </template>

    <template slot="footer">
      <Tip>
        Utilize o formulário acima ou o nosso chat para falar com o nosso suporte
      </Tip>

      <Tip type="alert" size="small">
        Se precisar enviar algum arquivo, como comprovantes, utilize o chat
      </Tip>

      <button class="btn bg-purple" @click="openChat">
        <span>
          abrir chat
        </span>
      </button>

      <button class="btn bg-outlined" @click="$emit('close')">
        <span>
          fechar
        </span>
      </button>
    </template>
  </Modal>
</template>

<style scoped>
.support {
  height: 100vh;
  max-height: 290px;
}

.bg-outlined {
  padding: 8px 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/Support/Index.vue